import { render, staticRenderFns } from "./Fach.vue?vue&type=template&id=39963f09"
import script from "./Fach.vue?vue&type=script&lang=js"
export * from "./Fach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports